import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { useTheme } from "@material-ui/core/styles";
import { CircularProgress } from "@material-ui/core";
import { Layout } from "components/common";
import Footer from "components/Footer/Footer";
import Header from "components/modules/Auth/Header";
import {
  AUTH_ROOT_ROUTE,
  PHONE_VERIFICATION_ROUTE,
} from "routes/auth/authPaths";
import AuthRoutes from "routes/auth/AuthRoutes";
import { PORTAL_LAYOUT_ROUTE } from "routes/portal/portalPaths";
import { useStyles } from "./layoutStyles";

const allowLogged = [PHONE_VERIFICATION_ROUTE];

const Auth = () => {
  const classes = useStyles();
  const theme = useTheme();
  const history = useHistory();
  const location = useLocation();
  const { isAuthenticated } = useSelector(({ auth }) => auth);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const pathDoesNotAllowLogged = !allowLogged.find(
      (path) => AUTH_ROOT_ROUTE + path === location.pathname
    );

    if (isAuthenticated && pathDoesNotAllowLogged) {
      history.push(PORTAL_LAYOUT_ROUTE, {
        from: history.location?.state?.from,
      });
    } else {
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated]);

  return loading ? (
    <CircularProgress className={classes.loading} />
  ) : (
    <Layout
      bgColor={theme.palette.common.white}
      header={<Header />}
      content={<AuthRoutes />}
      footer={<Footer />}
    />
  );
};

export default Auth;
